<template>
  <div>
    <filter-transactions-history ref="FilterTransactionsHistory"/>
    <show-transactions-history ref="ShowPaymentHistory"/>
  </div>
</template>

<script>
  import ShowTransactionsHistory from "@/views/app/administration/components/ShowTransactionsHistory.vue";
  import FilterTransactionsHistory from "@/views/app/administration/components/FilterTransactionsHistory.vue";

  export default {
    components: {FilterTransactionsHistory, ShowTransactionsHistory}
  }

</script>
